<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2" v-if="sizes.length > 1">
      <span class="wf-w-1/2 wf-text-xs wf-tracking-wide wf-font-light wf-lowercase">size</span>
      <div class="wf-flex wf-w-1/2">
        <select class="wf-w-full" v-model="size">
          <option
              v-for="size in sizes"
              :key="size.key"
              :value="size.value"
              v-text="size.text"
          ></option>
        </select>
      </div>
    </li>
    <li v-if="size == 'custom'" class="wf-flex wf-flex-wrap wf-items-center wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-text-xs wf-tracking-wide wf-font-light wf-lowercase">custom size</span>
      <div class="wf-flex wf-flex-row wf-w-1/2 wf-flex-wrap wf-items-center">
        <div class="wf-w-5/12">
          <input
            type="text"
            v-model="customWidth"
            class="wf-w-full wf-text-center wf-text-xs wf-bg-gray-300 wf-rounded wf-px-2 wf-py-1"
            placeholder="W"
          />
        </div>
        <div class="wf-font-lightwf- wf-w-2/12 wf-text-center">x</div>
        <div class="wf-w-5/12">
          <input
            type="text"
            v-model="customHeight"
            class="wf-w-full wf-text-center wf-text-xs wf-bg-gray-300 wf-rounded wf-px-2 wf-py-1"
            placeholder="H"
          />
        </div>
      </div>
    </li>
  </div>
</template>

<script>
  import _ from 'lodash'
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    computed: {
      sizes() {
        if (this.elementContent.srcType == 'external') {
          return [
            {key: 'custom', value: 'custom', text: 'custom'},
          ]
        }
        return [
          {key: 'thumbnail', value: 'thumbnail', text: 'thumbnail'},
          {key: 'md', value: 'medium', text: 'medium'},
          {key: 'lg', value: 'large', text: 'large'},
          {key: 'original', value: 'original', text: 'original'},
          {key: 'custom', value: 'custom', text: 'custom'},
        ]
      },
      size: {
        get() {
          return this.elementContent.srcSize
        },
        set(value) {
          this.addToObject(this.module, {srcSize: value}, 'content', null, {}, true, this.parentModule)
          if (value != 'custom') {
            this.addToObject(this.module, {width: null}, this.styles, null, {}, true, this.parentModule)
            this.addToObject(this.module, {height: null}, this.styles, null, {}, true, this.parentModule)
          }
        }
      },
      customWidth: {
        get() {
          return this.elementStyles.width
        },
        set: _.debounce(function(value) {
          this.addToObject(this.module, {width: value}, this.styles, null, {}, true, this.parentModule)
        }, 500)
      },
      customHeight: {
        get() {
          return this.elementStyles(this.styles)[this.device].height
        },
        set: _.debounce(function(value) {
            this.addToObject(this.module, {height: value}, this.styles, null, {}, true, this.parentModule)
        }, 500)
      },
    }
  })
</script>